<template>
  <span class="term">
    <span v-if="term.coeff[0].s < 1" class="operator"> - </span>
    <div :class="{selected: calcCoeff}">
      <span v-if="! unit || term.isNumber"> {{ atom(term.coeff[0].abs()) }}</span>
      <span v-for="(c,i) of term.coeff.slice(1)" :key="'coeff'+i">
	<span v-if="i != 0 || ! unit" >×</span> {{ atom(c) }}
      </span>
    </div>
    <span v-if="(term.matrix.length > 0 || term.terms.length > 0) && (! unit || term.coeff.length > 1)"  class="mult"
	  :class="{selected: calcCoeff}"> × </span>
    <table v-if="term.matrix.length > 0" class="matrix det">
      <tr v-for="(row,i) of term.matrix" :key="'row' + i">
	<td v-for="(e,j) of row" :key="'col' + j" :class="cls(i,j)">
	  {{ e.toFraction() }}
	</td>
      </tr>
    </table>
    <template v-if="term.terms.length > 0">
      <span v-if="! term.root || term.coeff.length>1 || ! unit"> ( </span>
      <template v-for="(t,i) of term.terms">
	<span v-if="i != 0 && t.coeff[0].s > 0" :key="'plus'+i" class="operator" :class="{selected: canAdd && t.isNumber}"> + </span>
	<Exp :term="t" :op="op" :key="'e'+i"
	     :class="{selected: canAdd && t.isNumber}"></Exp>
      </template>
      <span v-if="! term.root || term.coeff.length>1 || ! unit"> ) </span>
    </template>
  </span>
</template>

<script>
import { Operation, zero, one, minus } from '@/lib/base.js';
import { Term } from '@/lib/det.js';

export default {
  name: 'Exp',
  props: {
    term: Term,
    op: {type:Operation, default:null}
  },
  methods: {
    atom(f){
      let txt = f.toFraction();
      if(f.d != 1 || f.s < 0){
	txt = '( ' + txt + ' )';
      }
      return txt;
    },
    cls(i,j){
      if(this.op == null || this.op.num != this.term.num || this.op.type == 'calc'){
	return '';
      }else if(this.op.type == 'deg'){
	if(i == 0 && j == 0){
	  return 's1';
	}else if(i >=1 && j >= 1){
	  return 'selected';
	}else{
	  return '';
	}
      }else if(this.op.type == 'surrus'){
	return 'selected';
      }else if(this.op.type == 'expand'){
	if( this.op.rc == 'row' && i == this.op.expand_i){
	  return 's1r';
	}else if(this.op.rc == 'col' && j == this.op.expand_i ){
	  return 's1c';	  
	}else{
	  return 'selected';
	}
      }else if(this.op.type == 'mult'){
	if(this.op.rc == 'row' && i == this.op.mult_i){
	  return 's1r';
	}else if(this.op.rc == 'col' && j == this.op.mult_i ){
	  return 's1c';
	}else{
	  return '';
	}
      }else if(this.op.type == 'swap'){
	if( this.op.rc == 'row' && (i == this.op.swap_i1 || i == this.op.swap_i2) ){
	  return 's2r';
	}else if(this.op.rc == 'col' && (j == this.op.swap_i1 || j == this.op.swap_i2) ){
	  return 's2c';
	}else{
	  return '';
	}
      }else if(this.op.type == 'add'){
	if( this.op.rc == 'row' && i == this.op.add_i1){
	  return 's3r';
	}else if(this.op.rc == 'col' && j == this.op.add_i1 ){
	  return 's3c';
	}else if( this.op.rc == 'row' && i == this.op.add_i2){
	  return 's1r';
	}else if( this.op.rc == 'col' && j == this.op.add_i2 ){
	  return 's1c';
	}else{
	  return '';
	}
      }
    }
  },
  computed: {
    unit(){
      return this.term.coeff[0].equals(one) || this.term.coeff[0].equals(minus)
    },
    calcCoeff(){
      return this.op != null && this.op.type == 'calc' &&
	(this.term.coeff.length > 1 || this.term.coeff[0].equals(zero) && (this.term.matrix.length > 0 || this.term.terms.length > 0) );
    },
    canAdd(){
      return this.op != null && this.op.type == 'calc' &&
	(this.term.terms.filter( t => t.isNumber ).length > 1 || this.term.terms.some( t => (t.isNumber && t.coeff[0].equals(zero))) );
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.term {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.operator {
    margin-left: 10px;
    margin-right: 3px;    
}
.mult {
    margin-left: 4px;
    margin-right: 4px;    
}
.det {
    border-left: solid 2px black;
    border-right: solid 2px black;
}
.s1r {
    background-color: #fdd;
    border-left-color: #fdd;
    border-right-color: #fdd;
}
.s2r {
    background-color: #dfd;
    border-left-color: #dfd;
    border-right-color: #dfd;
}
.s3r {
    background-color: #ddf;
    border-left-color: #ddf;
    border-right-color: #ddf;
}
.s1r {
    background-color: #fdd;
    border-left-color: #fdd;
    border-right-color: #fdd;
}
.s2r {
    background-color: #dfd;
    border-left-color: #dfd;
    border-right-color: #dfd;
}
.s3r {
    background-color: #ddf;
    border-left-color: #ddf;
    border-right-color: #ddf;
}
.s1c {
    background-color: #fdd;
    border-top-color: #fdd;
    border-bottom-color: #fdd;
}
.s2c {
    background-color: #dfd;
    border-top-color: #dfd;
    border-bottom-color: #dfd;
}
.s3c {
    background-color: #ddf;
    border-top-color: #ddf;
    border-bottom-color: #ddf;
}
</style>
